import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { Row, Col } from "react-bootstrap";
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

export default function Chidlinputs(props) {

  const { errors, id, variant, helpText, inputColumnSize, hideEmptyOption, ...textFieldProps } = props;
  const columnSize = inputColumnSize || 12;

  const empty = [<option aria-label="None" value="" key={0} />];

  const noOfChilds = props.noofchilds;
  let options = [];
  if (noOfChilds) {
    for (let i = 0; i < parseInt(noOfChilds); i++) {
      options.push({ value: `${i + 1}`, label: `${i + 1} Child` })
    }
  } else {
    options = [
      { value: '1', label: '1 Child' },
      { value: '2', label: '2 Children' },
      { value: '3', label: '3 Children' },
      { value: '4', label: '4 Children' },
      { value: '5', label: '5 Children' },
      { value: '6', label: '6 Children' },
      { value: '7', label: '7 Children' },
      { value: '8', label: '8 Children' },
    ];
  }

  const menuItems = options && options.map((option, key) => {
    return <option value={option.value} key={key + 1} disabled={option.disabled}>{option.label}</option>
  });

  var allMenuItems;

  if (hideEmptyOption) {
    allMenuItems = menuItems;
  } else if (menuItems) {
    allMenuItems = empty.concat(menuItems);
  } else {
    allMenuItems = empty;
  }

  return (
    <Row>
      <Col xs={columnSize}>
        <FormControl
          fullWidth
          variant={variant || "filled"}
          error={!!errors}
        >
          <InputLabel htmlFor={id}>{props.label}</InputLabel>
          <Select
            native
            {...textFieldProps}
            inputProps={{
              id: id,
            }}
          >
            {allMenuItems}
          </Select>
          <FormHelperText id={`${id}-helper-text`} aria-describedby={`${id}-helper-text`}>{errors && errors.message}</FormHelperText>
        </FormControl>
      </Col>

      {helpText &&
        <Col xs={2}>
          <div className="d-flex mt-2">
            <Tooltip title={helpText}>
              <InfoIcon color="action"></InfoIcon>
            </Tooltip>
          </div>
        </Col>
      }
    </Row>
  )
}

Chidlinputs.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
  })),
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  variant: PropTypes.string,
  errors: PropTypes.object,
  hideEmptyOption: PropTypes.bool,
  helpText: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/Helpers/Input/Childoptions.js